"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.IconTooltip = exports.HelpTooltip = exports.CustomIconTooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _uuid = require("uuid");
var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _tooltip = require("@reach/tooltip");
require("@reach/tooltip/styles.css");
var _web = require("@react-spring/web");
var _theme = _interopRequireDefault(require("./theme"));
var _internalTypography = require("../../internal/internal-typography");
var _constants = require("../../utils/constants");
var _tooltip_question_icon = _interopRequireDefault(require("./tooltip_question_icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThemeableTooltipPopupContentCSS = (0, _styledComponents.css)(["", ";display:inline-block;color:", ";background-color:", ";border:none;border-radius:0.3125rem;box-shadow:0 2px 6px ", ";box-sizing:border-box;font-size:1rem;padding:", ";white-space:normal;", " overflow-wrap:break-word;width:fit-content;z-index:", ";"], _internalTypography.bodyStyles, function (_ref) {
  var $theme = _ref.$theme;
  return $theme.color;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.backgroundColor;
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.boxShadowColor;
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.padding;
}, function (_ref5) {
  var $label = _ref5.$label;
  return typeof $label == 'string' && 'max-width: 12.5rem;';
}, _constants.Z_INDEX_MAP.tooltip);
var ThemeableTooltipPopupContent = (0, _web.animated)((0, _styledComponents["default"])(_tooltip.TooltipPopup).withConfig({
  displayName: "tooltips__ThemeableTooltipPopupContent"
})(["&[data-reach-tooltip]{", ";}"], ThemeableTooltipPopupContentCSS));
var StyledMuiTooltipWrapper = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__StyledMuiTooltipWrapper"
})(["& .MuiTooltip-tooltip.MuiTooltip-tooltip{", ";}"], ThemeableTooltipPopupContentCSS);

// Center the tooltip, but collisions will win
var centered = function centered(triggerRect, tooltipRect) {
  var triggerCenter = triggerRect.left + triggerRect.width / 2;
  var left = triggerCenter - tooltipRect.width / 2;
  var maxLeft = window.innerWidth - tooltipRect.width - 2;
  var positionTooltipResults = (0, _tooltip.positionTooltip)(triggerRect, tooltipRect);
  return {
    left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
    top: positionTooltipResults.top
  };
};
var TriggerWrapper = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__TriggerWrapper"
})(["display:inline-flex;"]);
var FlexContainer = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__FlexContainer"
})(["display:flex;"]);
var ThemeableTooltip = function ThemeableTooltip(props) {
  var children = props.children,
    label = props.label,
    ariaLabel = props.ariaLabel,
    propagateClickEvent = props.propagateClickEvent,
    theme = props.theme;
  var eventHandler = function eventHandler(event) {
    if (!propagateClickEvent) {
      event.preventDefault();
    }
  };
  var _useTooltip = (0, _tooltip.useTooltip)({
      onMouseDown: eventHandler,
      onPointerDown: eventHandler
    }),
    _useTooltip2 = (0, _slicedToArray2["default"])(_useTooltip, 3),
    trigger = _useTooltip2[0],
    tooltip = _useTooltip2[1],
    isVisible = _useTooltip2[2];
  var springStyles = (0, _web.useSpring)({
    opacity: isVisible ? '1' : '0',
    display: isVisible ? 'inherit' : 'none'
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(TriggerWrapper, (0, _extends2["default"])({}, trigger, (0, _constants.getDataProvidesProps)(props)), children)), /*#__PURE__*/React.createElement(ThemeableTooltipPopupContent, (0, _extends2["default"])({}, tooltip, {
    $theme: theme,
    label: label,
    "aria-label": ariaLabel,
    position: centered,
    style: springStyles
  })));
};
var Tooltip = exports.Tooltip = function Tooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip["default"]
  }), props.children);
};
Tooltip.defaultProps = {
  'data-provides': 'tooltip'
};
var IconTooltip = exports.IconTooltip = function IconTooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip.icon
  }), /*#__PURE__*/React.createElement(props.icon));
};
IconTooltip.defaultProps = {
  'data-provides': 'icon-tooltip'
};
var CustomIconTooltip = exports.CustomIconTooltip = function CustomIconTooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip.icon
  }), props.children);
};
CustomIconTooltip.defaultProps = {
  'data-provides': 'icon-tooltip'
};
var HelpTooltipTriggerWrapper = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__HelpTooltipTriggerWrapper"
})(["display:flex;"]);
var HelpTooltip = exports.HelpTooltip = function HelpTooltip(props) {
  var label = props.label,
    ariaLabel = props.ariaLabel;
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isVisible = _React$useState2[0],
    setIsVisible = _React$useState2[1];
  var id = 'tooltip-' + (0, _uuid.v4)();
  return /*#__PURE__*/React.createElement(StyledMuiTooltipWrapper, {
    $theme: _theme["default"].tooltip["default"],
    $label: label
  }, /*#__PURE__*/React.createElement(_ClickAwayListener["default"], {
    onClickAway: function onClickAway() {
      return setIsVisible(false);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Tooltip["default"], {
    PopperProps: {
      disablePortal: true
    },
    id: id,
    TransitionComponent: _Fade["default"],
    open: isVisible,
    disableHoverListener: true,
    disableTouchListener: true,
    interactive: true,
    title: label || '',
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(HelpTooltipTriggerWrapper, (0, _extends2["default"])({
    "aria-describedby": id,
    "data-state": isVisible ? 'tooltip-visible' : 'tooltip-hidden',
    onClick: function onClick(e) {
      setIsVisible(true);
      e.preventDefault();
    },
    onFocus: function onFocus(e) {
      setIsVisible(true);
      e.preventDefault();
    },
    onBlur: function onBlur(e) {
      setIsVisible(false);
      e.preventDefault();
    }
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_tooltip_question_icon["default"], null))))));
};
HelpTooltip.defaultProps = {
  'data-provides': 'help-tooltip'
};